/**
 * Configuración de tokens de acceso para APIs externas
 * 
 * Estos tokens son estáticos y se obtienen manualmente desde las APIs de Keikaku y SAT.
 * Si un token expira o cambia, debe actualizarse aquí.
 * 
 * NOTA: En producción, estos tokens deberían estar en variables de entorno (.env)
 * para mayor seguridad.
 */

// Token de acceso para la API de Keikaku
export const KEIKAKU_ACCESS_TOKEN = 'ro0maFSxfLRB7AEdvQ8Q3sgDfxen2kwRJ-XkqMcT8rcOSlIKsK4fSWRgH7-pwCYNqMYz3uOxC-W4KApWPRjvx9EDrfFlT-7iB1MX4uX7MZP70NGAVw6X--ih05aoZsQeyp_wEduSkO5ThS4vevZAuHNzYN0LfJhQdlNF8eIlvLSZdcz2AECcjldXMEZgoGLcteauTau_9C6OiESM-ha1OpZsCqDTBSfKn35IQ-4-AjjVF-9bgmJ0D1JIkfNm34WQlOCsS1yB13haXTWlZxzL1hp9DnfSg5Cu3-jWubntrbc';

// Token de acceso para la API de SAT
export const SAT_ACCESS_TOKEN = 'aZ26m-IZGH1ASqR17CQd7L_02oeh7oYEgnIeGmfnLRujgznEaws16QZ_XJ992HiSEAD22CoNQ7SHBMI7NbTurIh-4yllFI7P0cC3FHvdhOiOByR0iqMpD4Mzx1Eq9nX-emmBq1IbFilO7G7TGCzPYqjdZUMja0-osCNbBYNzllTCmaFry3sKZEZfbe82DscZe-_nTJ0G50jiOFpeQvkJMg';

// URLs base de las APIs
export const KEIKAKU_API_BASE_URL = 'https://aplicaciones.salvadorvertical.com/Keikaku/webapi';
export const SAT_API_BASE_URL = 'https://aplicaciones.salvadorvertical.com/SAT/webapi';

